// src/components/sections/FAQ.jsx
// Accordion FAQ - light theme

import React, { useState } from 'react';
import useInView from '../../hooks/useInView';

const FAQS = [
  {
    question: 'What is GPS Tech?',
    answer:
      'GPS Tech is a technology holdings company founded in South Africa, specialising in GPS telemetry, fleet management, and vehicle tracking software. We build and operate TripData, GeoDrive, and GeoFleet.',
  },
  {
    question: 'How do TripData and GeoDrive differ?',
    answer:
      "TripData is a native mobile app that tracks your trips automatically using your phone's GPS with 30-second accuracy. GeoDrive is a device-agnostic platform (web, Windows, macOS) that lets you import trip data from any GPS device or tracking provider, enrich it, and export SARS-compliant logbooks. Both produce SARS-compliant reports.",
  },
  {
    question: 'When is GeoFleet launching?',
    answer:
      'GeoFleet is targeting a Q2 2026 launch. It will be an enterprise-grade fleet management suite covering vehicle lifecycle management, maintenance scheduling, and compliance tracking.',
  },
  {
    question: 'Are your products SARS-compliant?',
    answer:
      'Yes. Both TripData and GeoDrive produce SARS-compliant logbooks and reports that meet South African Revenue Service requirements for travel deductions.',
  },
  {
    question: 'Do you offer hardware or just software?',
    answer:
      'GPS Tech is a software company. That said, we have an affiliation with eLogger, which offers robust, long memory-holding GPS devices. We can recommend compatible hardware based on your requirements, but our core focus is software.',
  },
  {
    question: 'How can I get in touch?',
    answer:
      'You can reach us at hello@gpstech.co.za. We are founded in Gauteng, South Africa and serve clients globally.',
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [headerRef, headerInView] = useInView();
  const [listRef, listInView] = useInView({ threshold: 0.05 });

  return (
    <section id="faq" className="py-16 md:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div
          ref={headerRef}
          className={`text-center mb-16 transition-all duration-700 ${
            headerInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h2 className="text-3xl md:text-4xl font-display font-bold tracking-tight mb-4 text-gt-dark-100">
            Questions? <span className="text-gradient">Answers.</span>
          </h2>
          <p className="text-lg max-w-xl mx-auto text-gt-dark-400">
            Everything you need to know about GPS Tech and our platforms.
          </p>
        </div>

        {/* FAQ list */}
        <div ref={listRef} className="max-w-2xl mx-auto">
          {FAQS.map((faq, i) => (
            <div
              key={i}
              className={`border-b border-gt-silver-200 last:border-b-0 transition-all duration-500 ${
                listInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
              }`}
              style={{ transitionDelay: listInView ? `${i * 60}ms` : '0ms' }}
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full py-5 flex items-center justify-between text-left group"
              >
                <span className="text-base font-medium pr-8 text-gt-dark-100 group-hover:text-teal-600 transition-colors">
                  {faq.question}
                </span>
                <svg
                  className={`w-5 h-5 flex-shrink-0 text-gt-silver-400 transition-transform duration-300 ${
                    openIndex === i ? 'rotate-180' : ''
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? 'max-h-96 pb-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm leading-relaxed text-gt-dark-400">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;